import React from "react";
import { CustomTitleSubtitleListComponent, CustomTitle, NumberTypography, CustomSubTitle } from "./TitleSubtitleList.styles";
import { SubTitleSizeStyles, TitleSizeStyles } from "./TitleSubtitleList.variants";
import { useTheme } from "@mui/material/styles";

export interface CustomTitleSubtitleListProps {
    title?: string | React.ReactElement;
    subTitle?: string | React.ReactElement;
    size?: "sm" | "md";
    centered?: boolean;
    number?: number;
}

export const TitleSubtitleList = ({
    title,
    subTitle,
    size = "md",
    centered,
    number,
    ...rest
}: CustomTitleSubtitleListProps) => {
    const theme = useTheme();

    const titleSizeStylesFn = TitleSizeStyles(theme);
    const subTitleSizeStylesFn = SubTitleSizeStyles(theme);

    return (
        <CustomTitleSubtitleListComponent>
            <CustomTitle
                sx={{
                    ...titleSizeStylesFn[size],
                    textAlign: centered ? "center" : "inherit"
                }}
                {...rest}>
                {number && (
                    <NumberTypography>
                        {number}:&nbsp;
                    </NumberTypography>
                )}
                {title}
            </CustomTitle>
            <CustomSubTitle
                sx={{
                    ...subTitleSizeStylesFn[size],
                    textAlign: centered ? "center" : "inherit"
                }}>
                {subTitle}
            </CustomSubTitle>
        </CustomTitleSubtitleListComponent>
    );
};

export interface TitleSubtitleListProps extends React.ComponentProps<typeof TitleSubtitleList> {
    as?: React.ElementType;
}

TitleSubtitleList.displayName = "TitleSubtitleList";